/* Copyright (C) Okahu Inc 2023-2024. All rights reserved. */
import { Dispatch, SetStateAction } from 'react';
import { kahuCopyInfoType } from 'types/kahu';

import { TraceIdLink } from '../prompt-list/trace-id-link';
import { TraceFieldValue } from './trace-field-value';
import { TraceBlock } from './trace-list-utils';

export const TraceCard = function ({
  block,
  index,
  idLabel,
  messageId,
  copiedInfo,
  setCopiedInfo,
}: {
  block: TraceBlock;
  index: number;
  /** Entity-specific label derived from the fact type, e.g. "Trace ID",
   *  "Session ID", "Inference ID". */
  idLabel: string;
  messageId: string;
  copiedInfo: kahuCopyInfoType | null;
  setCopiedInfo: Dispatch<SetStateAction<kahuCopyInfoType | null>>;
}) {
  return (
    <div className="flex w-full flex-col">
      <span className="text-body-sm text-body-subtle">
        <span className="text-body font-bold text-[#EBEFF1]">
          {index + 1}. {idLabel}{' '}
        </span>
        <TraceIdLink
          block={block}
          occurrenceKey={`${messageId}:trace-card:${index}`}
          copiedInfo={copiedInfo}
          setCopiedInfo={setCopiedInfo}
        />
      </span>

      <div className="flex flex-col pl-4">
        {block.fields.map((field, fieldIndex) => (
          <div key={field.label} className="text-body text-body-subtle">
            <span>{field.label}: </span>
            <TraceFieldValue
              value={field.value}
              occurrenceKey={`${messageId}:trace-card:${index}:field:${fieldIndex}`}
              copiedInfo={copiedInfo}
              setCopiedInfo={setCopiedInfo}
            />
          </div>
        ))}
      </div>
    </div>
  );
};
